import { useState } from 'react';

import { DraftShareholder } from '@blockpulse3/graphql/hooks';

import { ShareholderForm } from '../../Forms/ShareholderInformationsForm';
import { useSPVForm } from '../../provider';
import { draftShareholderDefaultValues } from '../../provider/schema';

type Props = {
  /* ** Callback of the Cancel button ** */
  onCancel: () => void;
  /* ** Callback of the Submit button ** */
  onSubmit: (data: DraftShareholder) => void;
};

/**
 * ShareholderInformationsStep.
 * Step that renders the form for the main shareholder of the SPV.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function ShareholderInformationsStep({ onCancel, onSubmit }: Props): JSX.Element {
  const { companyDraftContent } = useSPVForm();
  const { initialShareholder } = companyDraftContent;

  /* ** State updating the default form values with the switch toggle ** */
  const [defaultValues, setDefaultValues] = useState<DraftShareholder>(initialShareholder);

  /* ** Cancel, go back to the previous step ** */
  const handleStepCancel = (): void => {
    onCancel();
  };

  /* ** Returns shareholder form, go to next step ** */
  const handleStepSubmit = (data: DraftShareholder): void => {
    onSubmit(data);
  };

  /* ** Set default legal shareholder form value on legal switch ** */
  const handleToggleLegalSwitch = (): void => {
    setDefaultValues(draftShareholderDefaultValues);
  };

  /* ** Set user default natural sharheholder form values on natural switch ** */
  const handleToggleNaturalSwitch = (isNatural: boolean): void => {
    /*
			if (isNatural && mainIdentity) {
				const date = dayjs(mainIdentity.birthdate).format('YYYY-MM-DD');
				setDefaultValues((prevDefault) => ({
					...prevDefault,
					isLegal: true,
					shareholder: {
						...prevDefault.shareholder,
						firstName: mainIdentity.firstName,
						lastName: mainIdentity.lastName,
						birthdate: date,
						address: mainIdentity.address,
						nationality: { label: mainIdentity.nationality, value: 'FRA' },
					},
				}));
			} else {
				setDefaultValues(shareholderDefaultValues(false));
			}
		*/
  };

  return (
    <ShareholderForm
      isDisabled
      shouldDisabledSwitches
      defaultValues={defaultValues}
      onCancel={handleStepCancel}
      onSubmit={handleStepSubmit}
      onToggleLegalSwitch={handleToggleLegalSwitch}
      onToggleNaturalSwitch={handleToggleNaturalSwitch}
    />
  );
}

export type ShareholderInformationsStepProps = Props;
